const BASES: Record<string, string> = {
  asia:   'https://asia-southeast1-davids-beacon.cloudfunctions.net',
  europe: 'https://europe-west1-davids-beacon.cloudfunctions.net',
  us:     'https://us-central1-davids-beacon.cloudfunctions.net',
}

function devBase(): string {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
  if (/^(Asia|Pacific|Australia|Indian)\//.test(tz)) return BASES.asia
  if (/^(Europe|Africa|Atlantic)\//.test(tz)) return BASES.europe
  return BASES.us
}

// In production: relative /api/... path — routes through Firebase Hosting CDN
// In dev: direct regional function URL based on local timezone
export function proxyUrl(name: string): string {
  return import.meta.env.DEV ? `${devBase()}/${name}` : `/api/${name}`
}
